module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-KELAS-PINTAR-MINGGUAN-1.6e5d0d3a.png";